import { http } from '@/core/api/';

export default {
  getParentinventoryitems(properties) {
    return http.get('api/parentInventory/parentinventoryitems', {
      params: {
        ...properties,
      },
    });
  },
  getParentinventorycounters(properties) {
    return http.get('api/parentInventory/parentinventorycounters', {
      params: {
        ...properties,
      },
    });
  },
  getSampleInventoryAcademicYears() {
    return http.get(`api/parentInventory/academicyears`);
  },
  getSampleInventoryStatuses() {
    return http.get(`api/code/getallsampleinventorystatuses`);
  },
};
